<template>
    <div>
        <div v-if="!submitSuccess" style="margin-left: 20px; margin-right: 20px;">
            <div>
                <label for="incident-date">Choose a date</label>
                <b-form-datepicker id="incident-date"
                                   v-model="incidentDate"
                                   class="mb-2"
                                   locale="en"></b-form-datepicker>
                <p>Current incident date: '{{ selectedClaim.incidentDate }}'</p>
                <!-- <p>Updated incident date: '{{ new Date(incidentDate).toLocaleDateString('en-GB', options) }}'</p> -->
            </div>
            <b-form-group id="reason-select-group" label="Reason" label-for="reason-select">
                <b-form-select id="reason-select" v-model="selectedReason" :options="changeReasons" required></b-form-select>
            </b-form-group>
            <div style="display: flex; flex-direction: column;">
                <span><i>Ensure you have the correct date</i></span>
                <button class="btn btn-success"
                        v-on:click="updateIncidentDate()"
                        :disabled="isError">
                    Update
                </button>
                <span v-if="errorMessage"><i style="color: red;">{{ errorMessage }}</i></span>
            </div>
        </div>
        <div v-else>
            <h3>Validation pipelines need may need to be rerun and excess may need recalculating.</h3>
        </div>
    </div>
</template>

<script>
import { claimIncidentWithinCoverDates } from '../../util/pipelines/claimRules';

    export default {
        name: 'incidentDateForm',
        data() {
            return {
                incidentDate: '',
                changeReasons: [{ text: 'Select reason', value: null }, 'Customer requested', 'Customer input error', 'Other'],
                selectedReason: null,
                submitSuccess: false,
                isLoading: false,
                errorMessage: '',
                isError: true,
                options: {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                }
            }
        },
        methods: {
            updateIncidentDate() {
                this.isLoading = true;
                //call a store action --> call api update claim

                this.$store.dispatch('updateClaimIncidentDate', {incidentDate: this.incidentDate, id: this.selectedClaim.incidentId});
                this.submitSuccess = true;

                this.isLoading = false;
            },
            validateSubmission() {
                var valid = true;
                this.errorMessage = null;

                if(this.incidentDate) {
                    let selectedClaimCopy = Object.assign({}, this.selectedClaim);
                    selectedClaimCopy.incidentDetails.incidentDate = this.incidentDate;
                    var result = claimIncidentWithinCoverDates({objectInstance: selectedClaimCopy});
                    if(result && !result.success) {
                        this.errorMessage = result.message.body
                        valid = false;
                    }
                } else {
                    this.errorMessage = 'Incident date is required.'
                    valid = false;
                }

                if(!this.selectedReason) {
                    if(!this.errorMessage) {
                        this.errorMessage = 'Reason is required.';
                    } else {
                        this.errorMessage += ' || Reason is required.';
                    }

                    valid = false;
                }

                if(valid) {
                    this.isError = false;
                }
            }
        },
        computed: {
            selectedClaim() {
                return this.$store.getters.selectedClaim
            }
        },
        watch: {
            'incidentDate': function (newVal, oldVal) {
                this.validateSubmission();
            },
            'selectedReason': function (newVal, oldVal) {
                this.validateSubmission();
            }
        }
    }
</script>